import { z } from 'zod';

/**
 * Перечисления, общие для API и SPA.
 * Значения обязаны совпадать с enum'ами Prisma (§ конвенции CLAUDE.md: SCREAMING_SNAKE_CASE).
 */

export const RoleSchema = z.enum(['SYS_ADMIN', 'MANAGER_HEAD', 'PROJECT_MANAGER', 'ANALYST']);
export type Role = z.infer<typeof RoleSchema>;

export const AppModeSchema = z.enum(['EMBEDDED_INTEGRATED', 'EXTERNAL_INTEGRATED', 'STANDALONE']);
export type AppMode = z.infer<typeof AppModeSchema>;

export const EmployeeStatusSchema = z.enum(['ACTIVE', 'BLOCKED', 'ARCHIVED']);
export type EmployeeStatus = z.infer<typeof EmployeeStatusSchema>;

export const ProjectStatusSchema = z.enum(['ACTIVE', 'INACTIVE', 'ARCHIVED']);
export type ProjectStatus = z.infer<typeof ProjectStatusSchema>;

export const PersonStatusSchema = z.enum(['ACTIVE', 'BLOCKED']);
export type PersonStatus = z.infer<typeof PersonStatusSchema>;

export const LinkStatusSchema = z.enum(['INVITED', 'ACTIVE', 'REVOKED']);
export type LinkStatus = z.infer<typeof LinkStatusSchema>;

export const ChannelKindSchema = z.enum(['TELEGRAM', 'MAX']);
export type ChannelKind = z.infer<typeof ChannelKindSchema>;

export const InviteStatusSchema = z.enum(['ACTIVE', 'USED', 'EXPIRED', 'REVOKED']);
export type InviteStatus = z.infer<typeof InviteStatusSchema>;

export const TemplateStatusSchema = z.enum(['DRAFT', 'PUBLISHED', 'ARCHIVED']);
export type TemplateStatus = z.infer<typeof TemplateStatusSchema>;

export const QuestionTypeSchema = z.enum(['RATING_1_5', 'SINGLE_CHOICE', 'TEXT']);
export type QuestionType = z.infer<typeof QuestionTypeSchema>;

export const ScheduleStatusSchema = z.enum(['ACTIVE', 'PAUSED', 'DISABLED']);
export type ScheduleStatus = z.infer<typeof ScheduleStatusSchema>;

export const RunStatusSchema = z.enum([
  'SCHEDULED',
  'SENT',
  'IN_PROGRESS',
  'COMPLETED',
  'EXPIRED',
  'CANCELLED',
]);
export type RunStatus = z.infer<typeof RunStatusSchema>;

/** E3 Дополнения №1: статусы инцидента симметричны обращению. */
export const IncidentStatusSchema = z.enum(['NEW', 'IN_PROGRESS', 'CLOSED', 'REJECTED']);
export type IncidentStatus = z.infer<typeof IncidentStatusSchema>;

export const RequestTypeSchema = z.enum(['COMPLAINT', 'EXTRA_SERVICE', 'CHANGE_SERVICE']);
export type RequestType = z.infer<typeof RequestTypeSchema>;

export const RequestStatusSchema = z.enum(['NEW', 'ACCEPTED', 'IN_PROGRESS', 'CLOSED', 'REJECTED']);
export type RequestStatus = z.infer<typeof RequestStatusSchema>;

export const OutboxStatusSchema = z.enum([
  'PENDING',
  'IN_PROGRESS',
  'DONE',
  'FAILED',
  'NEEDS_ATTENTION',
  'NEEDS_RECONCILIATION',
]);
export type OutboxStatus = z.infer<typeof OutboxStatusSchema>;

export const OutboxTargetSchema = z.enum(['BITRIX24', 'TELEGRAM', 'MAX']);
export type OutboxTarget = z.infer<typeof OutboxTargetSchema>;

/** E1 Дополнения №1: политика позднего ответа. */
export const LateAnswerPolicySchema = z.enum([
  'reject',
  'accept_no_incident',
  'accept_with_incident',
]);
export type LateAnswerPolicy = z.infer<typeof LateAnswerPolicySchema>;
